export const FixedClasses = {
  FIXED_TRUE : ['wf-fixed'],
  FIXED_FALSE : []
}